// resources/js/Pages/Formula/components/TableColumnManager.js
import React, { useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';

export default function TableColumnManager({ 
  columnId, 
  columnIndex,
  totalColumns,
  onAddColumnBefore,
  onAddColumnAfter, 
  onDeleteColumn,
  onMoveColumn
}) {
  const [showActions, setShowActions] = useState(false);

  return (
    <div 
      className="table-column-manager"
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
      style={{ 
        position: 'relative',
        width: '100%',
        height: '20px'
      }}
    >
      {showActions && (
        <div 
          className="column-actions"
          style={{
            position: 'absolute',
            top: '-10px',
            right: '8px',
            zIndex: 1000,
            display: 'flex',
            gap: '4px'
          }}
        >
          <Dropdown>
            <Dropdown.Toggle
              variant="outline-primary"
              size="sm"
              style={{
                width: '24px',
                height: '24px',
                padding: 0,
                borderRadius: '50%',
                fontSize: '12px',
                lineHeight: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              ⚙️
            </Dropdown.Toggle>

            <Dropdown.Menu align="end" style={{ zIndex: 2000 }}>
              <Dropdown.Header>Column Actions</Dropdown.Header>
              
              <Dropdown.Item onClick={() => onAddColumnBefore?.(columnIndex)}>
                <span className="me-2">⬅️</span>Add Column Before
              </Dropdown.Item>
              
              <Dropdown.Item onClick={() => onAddColumnAfter?.(columnIndex)}>
                <span className="me-2">➡️</span>Add Column After
              </Dropdown.Item>
              
              <Dropdown.Divider />
              
              {columnIndex > 0 && (
                <Dropdown.Item onClick={() => onMoveColumn?.(columnId, 'left')}>
                  <span className="me-2">⬅️</span>Move Left
                </Dropdown.Item>
              )}
              
              {columnIndex < totalColumns - 1 && (
                <Dropdown.Item onClick={() => onMoveColumn?.(columnId, 'right')}>
                  <span className="me-2">➡️</span>Move Right
                </Dropdown.Item>
              )}
              
              {totalColumns > 1 && (
                <>
                  <Dropdown.Divider />
                  <Dropdown.Item 
                    onClick={() => onDeleteColumn?.(columnId)}
                    className="text-danger"
                  >
                    <span className="me-2">🗑️</span>Delete Column
                  </Dropdown.Item>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      )}
    </div>
  );
}